import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

import { CustomStyles, getStyles } from "src/styles/theme";
import { Input } from "../../common/FormComponents";
import defaultStyles, { StylesClasses } from "./styles";

type FormInputs = {
  search: string;
};

const DEFAULT_DEBOUNCE_MS = 400;

type SearchProps = {
  placeHolder?: string;
  getText: (txt: string) => void;
  customStyles?: CustomStyles<StylesClasses>;
  defaultValue?: string;
  debounceMs?: number;
};

const SearchBar = ({
  getText,
  customStyles,
  placeHolder = "Search here",
  defaultValue = "",
  debounceMs = DEFAULT_DEBOUNCE_MS,
}: SearchProps) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: "onChange",
    defaultValues: {
      search: defaultValue,
    },
  });

  const styles = getStyles(defaultStyles, customStyles);

  const inputVal = watch("search");

  const getTextRef = useRef(getText);
  useEffect(() => {
    getTextRef.current = getText;
  });

  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    timerRef.current = setTimeout(
      () => getTextRef.current(inputVal),
      debounceMs,
    );

    return () => clearTimeout(timerRef.current);
  }, [inputVal, debounceMs]);

  const onSubmitForm = (formData: FormInputs) => formData;

  return (
    <Box {...styles("wrapper")}>
      <form onSubmit={handleSubmit(onSubmitForm)} style={{ width: "100%" }}>
        <Input
          control={control}
          labelPos
          labelPosStyles
          name="search"
          showAdornment
          adornmentPos="start"
          className="search"
          errors={errors}
          rules={{}}
          placeholder={placeHolder}
          customStyles={{ wrapper: defaultStyles.border }}
        />
      </form>
    </Box>
  );
};

export default SearchBar;
